import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getArticlesHints() {
    try {
        const response =  await api.get(STATE_MEDIA + "api/dashboard/hints-articles")
        return response.data?.items ?? []
    } catch (error) {
        console.error("ошибка загрузки Новостей", error?.message)
    }
}
